module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAAXNSR0IArs4c6QAAAM5JREFUGBljvGyiV8rIyHRA5/SF0wxo4JKJbjozA9N5JmZmpg3//v3desXUwBRZDUgBI8P/ajZRqYtg8cvGOt6XjHVfwRSCFFw20Xl0w0xPEaSAEaYbpPA/A+N8oO45QNEYViYme41Tl+7D5OH0JSPtyZdMdP5cNdH1hwsCGUwwDtgNTIz+QKPT/v5nmA2zGiQPVgRzJMgK3TNX5gGtTET2DOMlc11jxr//16O7AeRGoCELmHhFFJmY/jLYoSsAWaF79srW/4yM8Yzf3+kAAMgoTw01J847AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./resources/images/r-close_1x.png
// module id = 2318
// module chunks = 0